<template>
  <div>
    <div class="page-header">
      <div class="page-header-left">
        <ol class="breadcrumb ml-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'welcome' }">
              <feather type="home" />
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'vendorManagementDashboard' }">
              {{ $t('companyFormAdminView.vendorManagement') }}
            </router-link>
          </li>
          <li class="breadcrumb-item ">
            {{ $t('companyFormAdminView.daxilOlanMracitlr') }}
          </li>
        </ol>
      </div>
      <h4 class="my-3">
        {{ $t('companyFormAdminView.daxilOlanMracitlr') }}
      </h4>
    </div>

    <div class="row">
      <div
        v-if="isLoading"
        class="col-md-12"
      >
        <div class="alert alert-info">
          {{ $t('vendorManagementRequests.mlumatlarYklnir') }}
        </div>
      </div>
      <div
        v-else
        class="col-md-12"
      >
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 mb-3">
                <select
                  v-model="profileTypeFilter"
                  class="form-control"
                  required
                >
                  <option value="ALL">
                    {{ $t('companyVendors.btnProfillr') }}
                  </option>
                  <option value="SUPPLIER">
                    {{ $t('companyFormEdit.malVXidmtlrlBal') }}
                  </option>
                  <option value="LOGISTIC">
                    {{ $t('companyFormEdit.logistiklrN') }}
                  </option>
                  <option value="TRUCK">
                    {{ $t('companyFormEdit.trSahiblriN') }}
                  </option>
                </select>
              </div>

              <div
                v-if="profileTypeFilter==='SUPPLIER' || profileTypeFilter ==='ALL'"
                class="col-md-8 mb-3"
              >
                <Multiselect
                  v-model="selectedSector"
                  name="input_form"
                  :options="sectorVendorStatistics"
                  :multiple="false"
                  :taggable="false"
                  :allow-empty="true"
                  label="sectorName"
                  track-by="sectorId"
                  :placeholder="$t('vendorManagementPurchasesReports.btnFaliyytSahlri')"
                >
                  <template slot="beforeList">
                    <div>
                      <button
                        class="btn btn-outline-dark rounded-0"
                        @click="selectedSector = null"
                      >
                        {{ $t('vendorManagementPurchasesReports.btnFaliyytSahlri') }}
                      </button>
                    </div>
                  </template>
                </Multiselect>
              </div>
              <div class="col-md-4">
                <Multiselect
                  v-model="selectedForm"
                  name="input_form"
                  :options="forms"
                  :multiple="false"
                  :taggable="false"
                  :allow-empty="true"
                  :label="$t('newTRKRequest.name')"
                  track-by="id"
                  :placeholder="$t('vendorManagementRequests.btnDyrlndirmFormalar')"
                >
                  <template slot="beforeList">
                    <div>
                      <button
                        class="btn btn-outline-dark rounded-0"
                        @click="selectedForm = null"
                      >
                        {{ $t('vendorManagementRequests.btnDyrlndirmFormalar') }}
                      </button>
                    </div>
                  </template>
                </Multiselect>
              </div>
              <div class="col-md-4">
                <select
                  v-model="requestStatusFilter"
                  class="form-control"
                >
                  <option value="ALL">
                    {{ $t('vendorManagementPurchasesReports.hams') }}
                  </option>
                  <option value="MESSAGE">
                    {{ $t('supplierOutgoingVendorRequest.oxunmamMesaj') }}
                  </option>
                  <option value="CONVERSATION">
                    {{ $t('vendorManagementRequests.mzakir') }}
                  </option>
                  <option value="WAITING">
                    {{ $t('supplierOutgoingVendorRequest.gzlmd') }}
                  </option>
                  <option value="APPROVED">
                    {{ $t('supplierOutgoingVendorRequest.tsdiqlnmi') }}
                  </option>
                  <option value="RETURNED">
                    {{ $t('supplierOutgoingVendorRequest.geriQaytarlb') }}
                  </option>
                  <option value="REJECTED">
                    {{ $t('supplierOutgoingVendorRequest.lvEdilib') }}
                  </option>
                </select>
              </div>
              <div class="col-md-4">
                <date-range-picker
                  ref="picker"
                  v-model="dateRange"
                  class="w-100"
                  opens="left"
                  :ranges="false"
                  :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                  :time-picker="false"
                  :linked-calendars="true"
                  :auto-apply="true"
                  :date-format="dateFormatDateRange"
                  @update="dateRangeSelected($event)"
                >
                  <template #input="picker">
                    {{ $t('vendorManagmentInputView.key', {moment: getMoment(picker.startDate ?? new Date()) , moment_2: getMoment(picker.endDate ?? new Date())}) }}
                  </template>
                </date-range-picker>
              </div>
            </div>
          </div>
          <div
            v-if="filteredRequests.length <1"
            class="card-body"
          >
            <div
              v-if="requestStatusFilter==='MESSAGE'"
              class="alert alert-info"
            >
              {{ $t('supplierOutgoingVendorRequest.oxunamamMesajnzOlanMracitinizYoxdur') }}
            </div>
            <div
              v-else-if="requestStatusFilter==='WAITING'"
              class="alert alert-info"
            >
              {{ $t('vendorManagementRequests.sizinGzlmdOlanTdarkMracitinizYoxdur') }}
            </div>
            <div
              v-else-if="requestStatusFilter==='APPROVED'"
              class="alert alert-info"
            >
              {{ $t('vendorManagementRequests.sizinTsdiqlnmiTdarkMracitinizYoxdur') }}
            </div>
            <div
              v-else-if="requestStatusFilter==='RETURNED'"
              class="alert alert-info"
            >
              {{ $t('vendorManagementRequests.sizinDzliNGeriGndrilmiTdarkMracitinizYoxdur') }}
            </div>
            <div
              v-else-if="requestStatusFilter==='REJECTED'"
              class="alert alert-info"
            >
              {{ $t('vendorManagementRequests.sizinLvEdilmiTdarkMracitinizYoxdur') }}
            </div>
            <div
              v-else
              class="alert alert-info"
            >
              {{ $t('supplierOutgoingVendorRequest.uyunMracitTaplmad') }}
            </div>
          </div>
          <template v-for="r in filteredRequests">
            <hr class="my-0 py-0">
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-md-10">
                  <span class="h4">#{{ r.id }}</span>
                  <router-link
                    :to="{name: 'vendorManagementFormManage', params: {id: r.companyForm.id}}"
                    class="lead"
                  >
                    {{ r.companyForm.name }}
                  </router-link>
                </div>
                <div class="col-md-2 text-right">
                  <CompanyFormRequestStatus :status="r.status" />
                  <span
                    v-if="r.unreadMessageCountProcurement>0"
                    class="badge badge-danger blink"
                  >
                    {{
                      $t('vendorManagementRequests.runreadmessagecountprocurementYeniMesaj', {count: r.unreadMessageCountProcurement})
                    }}
                  </span>
                  <span
                    v-else-if="r.conversationActive"
                    class="badge badge-warning"
                  >
                    {{ $t('companyFormAdminView.mzakirAktivdir') }}
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-5 mb-2">
                  <strong>{{ $t('companyFormAdminView.irkt') }} </strong> {{ r.company.name }} {{ getCompanyFormat(r.company.format) }} <br>
                  <strong>{{ $t('supplierOutgoingVendorRequest.mllif') }} </strong> {{ r.user.name }} {{ r.user.surname }} <br>
                </div>
                <div class="col-md-7 mb-2">
                  <strong>{{ $t('companyFormAdminView.sonDyiiklik') }} </strong> {{
                    $t('vendorManagementRequests.rlastupdatetimeMomentddMmmYHm', {moment: getMoment(r.lastUpdateTime)})
                  }} <br>
                  <strong>{{ $t('companyFormAdminView.gndrilib') }} </strong>{{ getMoment(r.sendTime)}}<br>
                </div>
                <div
                  v-if="['RETURNED','REJECTED'].indexOf(r.status)>-1"
                  class="col-md-12"
                >
                  <div class="text-danger">
                    <strong>{{ $t('request.sbb2') }} </strong> {{ r.reason }}
                  </div>
                </div>
                <div class="col-md-10">
                  <div v-if=" r.companyForm.profileType === 'SUPPLIER'">
                    <strong>{{ $t('supplierOutgoingVendorRequest.faliyytSahlri') }} </strong>
                    <div v-for=" s in getRequestSectorList(r)">
                      - {{ s.sector.name }}
                    </div>
                  </div>
                </div>
                <div class="col-md-2 text-right ">
                  <button
                    class="btn btn-sm btn-outline-primary mt-auto"
                    @click="showRequestDetails(r.id)"
                  >
                    {{ $t('supplierOutgoingVendorRequest.trafl') }}
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>


    <b-modal
      id="modal-vendor-request"
      size="xl"
      centered
      :title="$t('supplierOutgoingVendorRequest.mracitDetallar')"
      scrollable
      :hide-footer="true"
      class="theme-modal"
      :busy="false"
      :no-enforce-focus="true"
      @close="closeRequestDetails"
    >
      <VendorRequestDetailsReceiver
        v-if="activeRequestId>0"
        :active-request-id="activeRequestId"
        @confirmRequest="confirmRequest($event)"
      />
    </b-modal>


    <b-modal
      id="modal-request-confirm"
      size="lg"
      centered
      :title="$t('companyFormAdminView.mracitinTsdiqlnmsi')"
      scrollable
      :hide-footer="true"
      class="theme-modal"
      :busy="false"
      :no-enforce-focus="true"
      @close="loadRequestList"
    >
      <ConfirmVendorRequestModal
        :confirm-request-details="confirmRequestDetails"
        @updated="showRequestDetails(confirmRequestDetails.requestId)"
      />
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {getFormIncomingRequests, getFormList, getFormSectorStatistics} from "@/repositories/VendorManagementRepository";

import Multiselect from 'vue-multiselect'
import {getCompanyFormat} from "@/repositories/Utils";
import VendorRequestDetailsReceiver from "@/pages/scc/vendorManagement/VendorRequestDetailsReceiver.vue";
import ConfirmVendorRequestModal from "@/pages/scc/vendorManagement/ConfirmVendorRequestModal.vue";
import CompanyFormRequestStatus from "@/pages/scc/vendorManagement/utils/CompanyFormRequestStatus.vue";


import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment/moment";
import 'moment/locale/az'; // For Azerbaijani
import 'moment/locale/ru'; // For Russian
// English is included by default


export default {
  components: {
    CompanyFormRequestStatus,
    ConfirmVendorRequestModal, DateRangePicker,
    VendorRequestDetailsReceiver, Multiselect,
  },
  data() {
    return {
      mediaBase: mediaBase,
      isLoading: true,
      requestSectorFilter: 0,
      requestFormFilter: 0,
      requestStatusFilter: 'ALL',
      sectorVendorStatistics: [],
      requests: [],
      forms: [],
      activeRequestId: 0,
      confirmRequestDetails: null,
      profileTypeFilter: 'ALL',
      dateRange: {
        start: null,
        end: null
      },
      dateRangeStart: null,
      dateRangeEnd: null,
    }
  },
  watch: {
    "$route"() {
      this.requestStatusFilter = this.$route.query['status'] || 'ALL';
      this.profileTypeFilter = this.$route.query['profile'] || 'ALL';
      this.requestSectorFilter = this.$route.query['sector'] || 0;
      let requestId = this.$route.query['request'] || 0;
      if (requestId > 0) {
        this.showRequestDetails(requestId);
      }
    },

    profileTypeFilter() {
      if (this.profileTypeFilter !== 'SUPPLIER' && this.profileTypeFilter !== 'ALL') {
        this.requestSectorFilter = 0;
      }
    }

    /* requestStatusFilter(){
       this.$router.push({
         query:{ status:  this.requestStatusFilter, sector: this.requestSectorFilter}
       });
     },

     requestSectorFilter(){
       this.$router.push({
         query:{ status:  this.requestStatusFilter, sector: this.requestSectorFilter}
       });
     }*/
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),

    selectedForm: {
      get: function () {
        return this.forms.filter(option => option.id === this.requestFormFilter)[0]
      },
      set: function (v) {
        if (v === null) {
          this.requestFormFilter = 0;
        } else {
          this.requestFormFilter = v.id;
        }
      }
    },

    selectedSector: {
      get: function () {
        return this.sectorVendorStatistics.filter(option => option.sectorId === this.requestSectorFilter)[0]
      },
      set: function (v) {
        if (v == null) {
          this.requestSectorFilter = 0;
        } else {
          this.requestSectorFilter = v.sectorId;
        }
      }
    },
    filteredRequests() {

      console.log("filtering");

      let requests = [];

      if (this.requestStatusFilter === 'ALL') {
        requests = this.requests;
      } else if (this.requestStatusFilter === 'MESSAGE') {
        requests = this.requests.filter(r => r.unreadMessageCountProcurement > 0);
      } else if (this.requestStatusFilter === 'CONVERSATION') {
        requests = this.requests.filter(r => r.conversationActive);
      } else {
        requests = this.requests.filter(r => r.status === this.requestStatusFilter);
      }

      if (this.requestSectorFilter > 0) {
        requests = requests.filter(r => r.sectors.split(',').indexOf(this.requestSectorFilter + "") > -1);
      }
      if (this.requestFormFilter > 0) {
        requests = requests.filter(r => r.companyForm.id === this.requestFormFilter);
      }
      if (this.profileTypeFilter !== 'ALL') {
        requests = requests.filter(r => r.companyForm.profileType === this.profileTypeFilter);
      }

      if (this.dateRangeStart) {
        console.log(this.dateRangeStart);
        console.log(this.dateRangeEnd);
        requests = requests.filter(r => moment(r.sendTime).isAfter(this.dateRangeStart) && moment(r.sendTime).isBefore(this.dateRangeEnd));
      }


      return requests;

    }

  },
  mounted() {
    this.requestStatusFilter = this.$route.query['status'] || 'ALL';
    this.profileTypeFilter = this.$route.query['profile'] || 'ALL';
    this.requestSectorFilter = parseInt(this.$route.query['sector']) || 0;

    let requestId = this.$route.query['request'] || 0;
    if (requestId > 0) {
      this.showRequestDetails(requestId);
    }

    this.loadRequestList();
    this.getFormList();
    this.getFormFormSectorStatistics();

  },
  methods: {

    getMoment(time) {
      moment.locale(this.$i18n.locale)
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getRequestSectorList(r) {

      if (r.sectors) {

        let selectedIds = r.sectors.split(',');

        return r.companyForm.sectors.filter(s => selectedIds.indexOf(s.sector.id + '') > -1);
      } else {
        return [];
      }

    },
    confirmRequest(data) {
      this.confirmRequestDetails = data;
      this.$bvModal.hide('modal-vendor-request');
      this.$bvModal.show('modal-request-confirm')
    },

    showRequestDetails(id) {
      this.activeRequestId = id;
      this.$bvModal.show('modal-vendor-request');
    },
    closeRequestDetails() {
      this.activeRequestId = 0;
      this.$bvModal.hide('modal-vendor-request');
      this.$router.push({query:{
        ...this.$route.query ,
        request: null
        }});
      this.loadRequestList();
    },
    loadRequestList() {
      getFormIncomingRequests(this.token, 0).then(data => {
        this.isLoading = false;
        this.requests = data;
      })
    },
    getFormFormSectorStatistics() {

      getFormSectorStatistics(this.token).then(({code, statistics, requests30Days}) => {
        if (code === 200) {
          this.sectorVendorStatistics = statistics;
        }
      })

    },
    getFormList() {
      getFormList(this.token).then(list => {
        this.forms = list.filter(f => f.status === 'ACTIVE');
      })
    },
    dateFormatDateRange(classes, date) {
      return classes
    },
    dateRangeSelected() {
      this.dateRangeStart = moment(this.dateRange.startDate).format('YYYY-MM-DD 00:00:00');
      this.dateRangeEnd = moment(this.dateRange.endDate).format('YYYY-MM-DD 23:59:59');
    },
  }

}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
